export default "__VITE_ASSET__CbyqyBb3__"